// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select-buffer .scrollable{height:calc(100dvh - 264px)}", "",{"version":3,"sources":["webpack://./pos/app/scripts/components/select-buffer/select-buffer.scss"],"names":[],"mappings":"AACE,2BACE,2BAAA","sourcesContent":[".select-buffer {\n  .scrollable {\n    height: calc(100dvh - 264px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
